// extracted by mini-css-extract-plugin
module.exports = {"error":"else_error__6iw3d","text1":"else_text1__ZL7Io"};